import React, { useState, useEffect } from 'react';
import {main_url} from  './basefile';


import {
  Box,
  Typography,
  MenuItem,
  Select,
  Button,
  Paper,
  FormControl,
  InputLabel
} from '@mui/material';



const mockQuestions = [
  {
    id: 1,
    text: "What is your favorite color?",
    type: "multiple_choice",
    options: ["Red", "Blue", "Green"]
  },
  {
    id: 2,
    text: "Do you have any allergies?",
    type: "boolean",
    options: ["NO", "YES"]
  },
  {
    id: 3,
    text: "Describe your last visit to the doctor.",
    type: "text",
    options: []
  }
];

const QuestionBankViewer = ( {projectId}) => {
  const [questions, setQuestions] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [questions_count, setQuestionscount] = useState();
const [selectedIndex, setSelectedIndex] = useState(null);


  useEffect(() => {
    // Replace with API call if needed
    // find no of question for the project, then assgned order +1 
fetchprojectq();
    fetchQuestions();
    //setQuestions(mockQuestions);
  }, []);

   const submitToAPI = async () => {
   // get the total question count 
   const payload = {
        project: projectId,
        text: selectedQuestion.text,
        question_type: selectedQuestion.type,
        order: questions_count + 1, // or whatever index it is

        options: Array.isArray(selectedQuestion.options)
        ? selectedQuestion.options.map((opt) => ({
            id: opt.id,
            text: opt.text,
        }))
        : []  // fallback to empty array if undefined
    };
  

    const token  = localStorage.getItem('authToken');
    const project_pk = projectId;
   // alert(project_pk);

    try {
     
      const res = await fetch(`${main_url}/api/v1/projects/${project_pk}/questions/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const error = await res.text();
        throw new Error(`API error: ${error}`);
      }
    
      const data = await res.json();
      //alert(JSON.stringify(data));
      console.log('✅ Submitted:', data);
    
      alert('Questions submitted successfully!');
      setQuestions([]);
    } catch (err) {
      console.error('❌ Submission failed:', err.message);
      alert('Failed to submit questions.');
    }
  };


   const fetchprojectq = async () => {
    const token = localStorage.getItem('authToken');
    
    const project_pk =projectId;
    //alert(project_pk);
    try {
      const res = await fetch(`${main_url}/api/v1/projects/${project_pk}/questions/`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText);
      }

      const data = await res.json();
      
      setQuestionscount(data.pagination.count);
     // alert(data.pagination.count);
    } catch (error) {
      console.error('❌ Failed to fetch questions:', error.message);
      alert('Failed to fetch questions.');
    }
  };



   const fetchQuestions = async () => {
    const token = localStorage.getItem('authToken');
    try {
         //const res = await fetch(`http://13.201.185.64:8000/api/v1/question-templates/`,

      const res = await fetch(`${main_url}/api/v1/question-templates/`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) {
        throw new Error('Failed to fetch questions');
      }

      const data = await res.json();
      const formatted = data.results.map((q) => ({
        id: q.id,
        text: q.text,
        type: q.question_type,
        options: q.options || [],
      }));

      setQuestions(formatted);
    } catch (error) {
      console.error('Error fetching questions:', error);
      alert('Failed to fetch question bank');
    }
  };

  const handleChange = (event) => {
    const id = event.target.value;
    setSelectedId(id);
    const question = questions.find((q) => q.id === id);
    setSelectedQuestion(question);
  };

  return (
   // <Box p={5} maxWidth={600} mx="auto">
       <Box p={4} maxWidth={880} mx="auto"  bgcolor="#ffffffff" borderRadius={2} >
      <Typography variant="h5" gutterBottom fontWeight={"bold"}>
        Question Bank Viewer
      </Typography>

      <FormControl fullWidth margin="normal">
        <InputLabel>Select a Question</InputLabel>
        <Select
          value={selectedId}
          label="Select a Question"
          onChange={handleChange}
        >
          {questions.map((q) => (
            <MenuItem key={q.id} value={q.id}>
              {q.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedQuestion && (
        <Paper elevation={2} sx={{ p: 1, mt: 3, backgroundColor: '#f9f9f9' }}>

          <Typography variant="subtitle1"><strong>Question:</strong> {selectedQuestion.text}</Typography>
          <br></br>
          <Typography variant="body2"><strong>Type:</strong> {selectedQuestion.type}</Typography>
<br></br>
          {selectedQuestion.options && selectedQuestion.options.length > 0 && (
            <>
              <Typography variant="body2" ml={5}><strong>Options:</strong></Typography>
              <ul style={{ paddingLeft: 60 }}>
                {selectedQuestion.options.map((opt, index) => (
                  <li key={index} 
                 
                  
                   style={{
                          cursor: 'pointer',
                          fontWeight: selectedIndex === index ? 'bold' : 'normal',
                          color: selectedIndex === index ? '#1976d2' : 'inherit',
                       }}
                  >
                   {typeof opt === 'string' ? opt : opt.text || JSON.stringify(opt)}
                   
                    </li>
                  
                ))}
              </ul>
            </>
          )}
        </Paper>
      )}

      <Box mt={3} textAlign="center">
        <Button variant="contained" color="primary" disabled={!selectedQuestion}  onClick={submitToAPI}>
          Add to this Project
        </Button>
      </Box>
    </Box>
  );
};

export default QuestionBankViewer;
